module.exports = __webpack_public_path__ + "img/ic_32_hexagon_outline_white.cf4f3395.svg";